<template>
    <div class="mb-2">
        <div class="Rechteck-2280 tw-text-sm tw-p-4 inline-block align-middle">
            <input :type="type" :name="name" :id="name"/>
            <label class="form-switch-label" :for="name"></label>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            name: {
                required: true,
                type: String,
            },
            type: {
                required: true,
                type: String,
            }
        },
        data() {
            return {
                name: this.value
            }
        },
    }
</script>